<template>
  <div class="i-inline-countdown">
    <div>
      <div class="value">{{ countdown ? countdown.daysPadded : "00" }}</div>
      <div class="label">DAYS</div>
    </div>
    <div>
      <div class="value">{{ countdown ? countdown.hoursPadded : "00" }}</div>
      <div class="label">HOURS</div>
    </div>
    <div>
      <div class="value">{{ countdown ? countdown.minutesPadded : "00" }}</div>
      <div class="label">MINS</div>
    </div>
    <div>
      <div class="value">{{ countdown ? countdown.secondsPadded : "00" }}</div>
      <div class="label">SECS</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"
import type { CountdownState } from "@/composables/useCountdown"

const props = defineProps<{ countdown: CountdownState | null }>()

const countdown = computed(() => props.countdown)
</script>

<style scoped lang="scss">
.i-inline-countdown {
  @include flex(row, center, center, $gap: 24px);

  color: $white;
  text-align: center;
  user-select: none;

  .value {
    font-weight: 700;
    letter-spacing: 1px;
    font-size: 24px;
    line-height: 24px;
  }

  .label {
    font-weight: 500;
    opacity: 0.9;
    letter-spacing: 0.5px;
    font-size: 10px;
    line-height: 15px;
  }
}
</style>
